/** Sparse acacia cohorts use the ordinary flora materials, wind, tile-owned
 * trunk contact and near/far crossfade. Grass stays in the native grass system. */
import * as THREE from 'three';
import type {FloraLibrary} from './library';
import type {ClutterSets} from './clutter';
import type {SavannaData} from './savannaData';
import {floraTime} from './material';
import {makePooledFloraMesh} from './materialPool';
import {prepareScatterBounds} from './scatterLod';
import {palmColliders,type CoastalCollider} from './coastalHabitat';

export function mountSavanna(data:SavannaData,library:FloraLibrary,_clutter:ClutterSets,far=false) {
  const meshes:THREE.InstancedMesh[]=[],colliders:CoastalCollider[]=[];
  const groups=new Map<number,{geo:THREE.BufferGeometry;coarse?:THREE.BufferGeometry;items:{matrix:THREE.Matrix4;evidence:object}[]}>();
  const Y=new THREE.Vector3(0,1,0),up=new THREE.Vector3(),pos=new THREE.Vector3(),q=new THREE.Quaternion(),spin=new THREE.Quaternion(),scale=new THREE.Vector3();
  for(const p of data){
    let group=groups.get(p.variant);
    if(!group){
      const geo=(far?library.variantsFar('acacia','summer',2):library.variants('acacia','summer',2))[p.variant];
      groups.set(p.variant,group={geo,coarse:far?undefined:library.variantsFar('acacia','summer',2)[p.variant],items:[]});
    }
    up.fromArray(p.normal);q.setFromUnitVectors(Y,up).multiply(spin.setFromAxisAngle(Y,p.yaw));
    pos.fromArray(p.dir).multiplyScalar(p.radius);scale.setScalar(p.size);
    const matrix=new THREE.Matrix4().compose(pos,q,scale);
    group.items.push({matrix,evidence:{...p,position:pos.toArray()}});
    if(!far)colliders.push(...palmColliders(group.geo,matrix,p.size,'acacia'));
  }
  for(const group of groups.values()){
    const fadeFar=far?0:950,fadeNear=far?950:0;
    const mesh=makePooledFloraMesh(group.geo,group.items.length,{birth:floraTime(),fadeFar,fadeNear,height:group.geo.userData.acacia.height});
    group.items.forEach((item,i)=>mesh.setMatrixAt(i,item.matrix));mesh.instanceMatrix.needsUpdate=true;
    Object.assign(mesh.userData,{savanna:'acacia',savannaFar:far,fadeFar,fadeNear,coverEvidence:group.items.map(p=>p.evidence),
      scatterLodNear:260,scatterLodFar:340});
    mesh.castShadow=!far;mesh.receiveShadow=true;mesh.visible=false;
    prepareScatterBounds(mesh,group.coarse);meshes.push(mesh);
  }
  return {meshes,colliders};
}
